// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-scroll {
  height: calc(100vh - 100px);
  overflow: auto;
  padding: 1rem;
}

.home-kpi-row {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.home-kpi-item {
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: calc(25% - 0.75rem);
  max-width: calc(25% - 0.75rem);
}

@media (max-width: 575.98px) {
  .home-kpi-item {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(50% - 0.5rem);
    max-width: calc(50% - 0.5rem);
  }
}

.home-kpi-card {
  background: #fff;
  border: 1px solid #e6e9ef;
  border-radius: 10px;
  padding: 0.85rem;
  display: flex;
  align-items: center;
  gap: 0.7rem;
  height: 100%;
  box-shadow: 0 2px 8px rgba(11, 51, 131, 0.08);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.home-kpi-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(11, 51, 131, 0.18);
}

.home-kpi-icon {
  width: 42px;
  height: 42px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 1.15rem;
  flex-shrink: 0;
}

.home-kpi-value {
  font-size: 1.35rem;
  font-weight: 700;
  line-height: 1.1;
  color: #222;
}

.home-kpi-label {
  font-size: 0.72rem;
  color: #6c757d;
  line-height: 1.15;
}

.home-card {
  border: none;
  border-radius: 12px;
}

.home-card .card-header {
  background: linear-gradient(135deg, #0b3383, #0e48ad);
  color: #fff;
  font-weight: 600;
  border-radius: 12px 12px 0 0;
  padding: 0.7rem 1rem;
}

.home-card .card-body {
  background: rgba(255, 255, 255, 0.96);
  border-radius: 0 0 12px 12px;
}

.home-chart-body {
  height: 320px;
}

.home-table {
  margin-bottom: 0;
}

.home-table thead th {
  background: #f4f6fa;
  color: #0b3383;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  border-bottom: 2px solid #e2e6ee;
  white-space: nowrap;
}

.home-table td {
  font-size: 0.85rem;
}

.home-badge {
  display: inline-block;
  padding: 0.3em 0.7em;
  font-size: 0.72rem;
  font-weight: 600;
  border-radius: 20px;
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/service/css/Home.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,YAA6B;EAA7B,cAA6B;EAA7B,+BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE;IACE,YAA4B;IAA5B,cAA4B;IAA5B,8BAA4B;IAC5B,6BAA6B;EAC/B;AACF;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,6CAA6C;EAC7C,uDAAuD;AACzD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qDAAqD;EACrD,WAAW;EACX,gBAAgB;EAChB,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB","sourcesContent":[".home-scroll {\n  height: calc(100vh - 100px);\n  overflow: auto;\n  padding: 1rem;\n}\n\n.home-kpi-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n}\n\n.home-kpi-item {\n  flex: 0 0 calc(25% - 0.75rem);\n  max-width: calc(25% - 0.75rem);\n}\n\n@media (max-width: 575.98px) {\n  .home-kpi-item {\n    flex: 0 0 calc(50% - 0.5rem);\n    max-width: calc(50% - 0.5rem);\n  }\n}\n\n.home-kpi-card {\n  background: #fff;\n  border: 1px solid #e6e9ef;\n  border-radius: 10px;\n  padding: 0.85rem;\n  display: flex;\n  align-items: center;\n  gap: 0.7rem;\n  height: 100%;\n  box-shadow: 0 2px 8px rgba(11, 51, 131, 0.08);\n  transition: transform 0.15s ease, box-shadow 0.15s ease;\n}\n\n.home-kpi-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 16px rgba(11, 51, 131, 0.18);\n}\n\n.home-kpi-icon {\n  width: 42px;\n  height: 42px;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  font-size: 1.15rem;\n  flex-shrink: 0;\n}\n\n.home-kpi-value {\n  font-size: 1.35rem;\n  font-weight: 700;\n  line-height: 1.1;\n  color: #222;\n}\n\n.home-kpi-label {\n  font-size: 0.72rem;\n  color: #6c757d;\n  line-height: 1.15;\n}\n\n.home-card {\n  border: none;\n  border-radius: 12px;\n}\n\n.home-card .card-header {\n  background: linear-gradient(135deg, #0b3383, #0e48ad);\n  color: #fff;\n  font-weight: 600;\n  border-radius: 12px 12px 0 0;\n  padding: 0.7rem 1rem;\n}\n\n.home-card .card-body {\n  background: rgba(255, 255, 255, 0.96);\n  border-radius: 0 0 12px 12px;\n}\n\n.home-chart-body {\n  height: 320px;\n}\n\n.home-table {\n  margin-bottom: 0;\n}\n\n.home-table thead th {\n  background: #f4f6fa;\n  color: #0b3383;\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  border-bottom: 2px solid #e2e6ee;\n  white-space: nowrap;\n}\n\n.home-table td {\n  font-size: 0.85rem;\n}\n\n.home-badge {\n  display: inline-block;\n  padding: 0.3em 0.7em;\n  font-size: 0.72rem;\n  font-weight: 600;\n  border-radius: 20px;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
